import type { SourceResource } from "@prequel/import-react";
import { useListSources } from "@prequel/import-react";
import type { TableRow } from "@prequel/shared-components";

import ResourceTable from "@/components/ResourceTable";
import Timestamp from "@/components/Timestamp";
import { getVendorLabel } from "@/pages/import/vendors";

const COLUMNS = ["Name", "Provider ID", "Type", "Created"];

const mapSourceToRow = (source: SourceResource): TableRow => ({
  id: source.id,
  to: `/import/sources/${source.id}`,
  cells: [
    { value: source.name },
    { value: source.provider_id },
    { value: getVendorLabel(source.vendor) },
    { value: <Timestamp timestamp={source.created_at} /> },
  ],
});

const SourcesTable = () => {
  return (
    <ResourceTable<SourceResource>
      columns={COLUMNS}
      useQuery={useListSources}
      rowMapper={mapSourceToRow}
      emptyMessage="No sources configured."
    />
  );
};

export default SourcesTable;
